@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.feed.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.feed.resources/"

@delegate:ResourceContentHash(1_834_724_031)
internal val Res.plurals.feed_comments: PluralStringResource by lazy {
      PluralStringResource("plurals:feed_comments", "feed_comments", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 69),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("feed_comments", Res.plurals.feed_comments)
}
